import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FnAccordianPanelContentDirective } from './fn-accordian-panel-content.directive';
import { FnAccordianPanelHeaderComponent } from './fn-accordian-pannel-header/fn-accordian-panel-header.component';
import { FnAccordianComponent } from './fn-accordian.component';
import { FnAccordianPanelComponent } from './fn-accordian-pannel/fn-accordian-panel.component';

export * from './fn-accordian-pannel-header/fn-accordian-panel-header.component';
export * from './fn-accordian.component';
export * from './fn-accordian-pannel/fn-accordian-panel.component';
export * from './fn-accordian-panel-content.directive';
@NgModule({
	imports: [FormsModule, CommonModule],
	exports: [
		FnAccordianComponent,
		FnAccordianPanelComponent,
		FnAccordianPanelHeaderComponent,
		FnAccordianPanelContentDirective,
	],
	declarations: [
		FnAccordianComponent,
		FnAccordianPanelComponent,
		FnAccordianPanelHeaderComponent,
		FnAccordianPanelContentDirective,
	],
	providers: [],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FnAccordianModule {}
